import script from "./Power_WindBase_Design.vue?vue&type=script&setup=true&lang=js"
export * from "./Power_WindBase_Design.vue?vue&type=script&setup=true&lang=js"

import "./Power_WindBase_Design.vue?vue&type=style&index=0&id=1ab73ff5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ab73ff5"]])

export default __exports__